import { ProgressbarTemplate } from "themes/common/components";

function Progressbar(props) {
    return <ProgressbarTemplate {...props} />;
}

export default Progressbar;
